import {Component, OnInit} from 'angular2/core';
import {AlertComponent} from "./alert.component";
import {AlertService} from "./alert.service";
import {Router} from "angular2/router";
import {Alert} from "../../../models/alert.model";

/*
    This component displays a collection of alerts components. This component suscribes to an event emitter.
 */

@Component({
    selector: 'alerts',
    template: `
    <alert *ngFor="let alert of alerts;let i = index" [type]="alert.type" dismissible="true"
        (close)="closeAlert(i)" [closeable]="alert.closeable">
        {{ alert?.msg }}
    </alert>`,
    directives: [AlertComponent]
})
export class AlertsComponent implements OnInit {

    alerts:Array<Alert> = [];

    constructor(private _service:AlertService, private _router:Router) {
    }

    ngOnInit() {
        this._service.getChangeEmitter()
            .subscribe(alert => {
                    alert.status = 0;
                    this.alerts.push(new Alert(alert));
                }
            );

        this._router.subscribe(onNext => this.updateAlertsStatus());
    }

    private updateAlertsStatus() {
        for (var alert of this.alerts) {
            alert.status += 1;
            if (alert.status > 1) {
                this.alerts.splice(this.alerts.indexOf(alert), 1);
            }
        }
    }

    public closeAlert(i:number):void {
        this.alerts.splice(i, 1);
    }

}
